<template>
  <div>
    <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-5 pb-2 mb-3">
      <h2><span>Account</span></h2>
    </div>
    <h4 class="h4">Profile</h4>
    <div v-if="passwordChangeSuccess" class="alert alert-success alert-dismissible fade show" role="alert">
      <strong>Your password has been successfully changed</strong>
      <button type="button" class="close" aria-label="Close" @click="passwordChangeSuccess=null">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <form class="col-xl-8" v-on:submit.prevent="changePassword">
      <div class="form-group row">
        <label for="email" class="col-sm-2 col-form-label">Email</label>
        <div class="col-sm-10">
          <input type="text" readonly class="form-control-plaintext" id="email" :value="user.email">
        </div>
      </div>
      <div class="form-group row">
        <label for="old_password" class="col-sm-2 col-form-label">Old password</label>
        <div class="col-sm-10">
          <vue-password v-model="old_password"
                        id="old_password"
                        classes="input form-control"
                        placeholder="Old password"
                        :disableStrength="true">
          </vue-password>
          <div class="mb-3 invalid-feedback-password" v-if="error && error.old_password">
            <p v-for="(description,index) in error.old_password" :key="index">{{description}}</p>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <label for="new_password" class="col-sm-2 col-form-label">New password</label>
        <div class="col-sm-10">
          <vue-password v-model="new_password"
                        id="new_password"
                        classes="input form-control"
                        placeholder="New password"
                        :disableStrength="true">
          </vue-password>
          <div class="mb-3 invalid-feedback-password" v-if="error && error.new_password">
            <p v-for="(description,index) in error.new_password" :key="index">{{description}}</p>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-sm-12">
          <button type="submit" class="btn btn-primary mb-2 float-right" v-on:click="changePassword" :disabled="loadingPasswordChange"><icon name="settings" class="feather-spin" v-if="loadingPasswordChange"></icon> Change</button>
          <div class="mb-3 invalid-feedback-password" v-if="error && error.non_field_errors">
            <p v-for="(description,index) in error.non_field_errors" :key="index">{{description}}</p>
          </div>
        </div>
      </div>
    </form>
    <h4 class="h4">Business details</h4>
    <div v-if="updatedUserSuccess" class="alert alert-success alert-dismissible fade show" role="alert">
      <strong>Your business details have been successfully updated</strong>
      <button type="button" class="close" aria-label="Close" @click="updatedUserSuccess=null">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <form class="col-xl-8" v-on:submit.prevent="updateUserProfile">
      <div class="form-group row">
        <label for="full_name" class="col-sm-2 col-form-label">Full Name</label>
        <div class="col-sm-10">
          <input type="text" class="form-control"  id="full_name" placeholder="Full name" v-model="user.full_name" :disabled="loadingUser">
          <div class="mb-3 invalid-feedback-password" v-if="error && error.full_name">
            <p v-for="(description,index) in error.full_name" :key="index">{{description}}</p>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <label for="job_title" class="col-sm-2 col-form-label">Role/title</label>
        <div class="col-sm-10">
          <input type="text" class="form-control"  id="job_title"  placeholder="Role/title" v-model="user.job_title" :disabled="loadingUser">
          <div class="mb-3 invalid-feedback-password" v-if="error && error.job_title">
            <p v-for="(description,index) in error.job_title" :key="index">{{description}}</p>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <label for="business_name" class="col-sm-2 col-form-label">Business name</label>
        <div class="col-sm-10">
          <input type="text" class="form-control"  id="business_name"  placeholder="Business name" v-model="user.business_name" :disabled="loadingUser">
          <div class="mb-3 invalid-feedback-password" v-if="error && error.business_name">
            <p v-for="(description,index) in error.business_name" :key="index">{{description}}</p>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <label for="address" class="col-sm-2 col-form-label">Address</label>
        <div class="col-sm-10">
          <input type="text" class="form-control"  id="address"  placeholder="Address" v-model="user.address" :disabled="loadingUser">
          <div class="mb-3 invalid-feedback-password" v-if="error && error.address">
            <p v-for="(description,index) in error.address" :key="index">{{description}}</p>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <label for="country" class="col-sm-2 col-form-label">Country</label>
        <div class="col-sm-10">
          <select v-model="user.country" class="form-control" :disabled="loadingUser">
            <option value="" disabled>Select Country</option>
            <option v-for="c in countries" :key='c.code' v-bind:value="c.code">{{c.name}}</option>
          </select>
          <div class="mb-3 invalid-feedback-password" v-if="error && error.country">
            <p v-for="(description,index) in error.country" :key="index">{{description}}</p>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <label for="city" class="col-sm-2 col-form-label">City</label>
        <div class="col-sm-10">
          <input type="text" class="form-control"  id="city"  placeholder="City" v-model="user.city" :disabled="loadingUser">
          <div class="mb-3 invalid-feedback-password" v-if="error && error.city">
            <p v-for="(description,index) in error.city" :key="index">{{description}}</p>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <label for="postcode" class="col-sm-2 col-form-label">Postal/Zip code</label>
        <div class="col-sm-10">
          <input type="text" class="form-control"  id="postcode"  placeholder="Postal/Zip code" v-model="user.postcode" :disabled="loadingUser">
          <div class="mb-3 invalid-feedback-password" v-if="error && error.postcode">
            <p v-for="(description,index) in error.postcode" :key="index">{{description}}</p>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <label for="phone" class="col-sm-2 col-form-label">Phone</label>
        <div class="col-sm-10">
          <input type="text" class="form-control"  id="phone"  placeholder="Phone" v-model="user.phone" :disabled="loadingUser">
          <div class="mb-3 invalid-feedback-password" v-if="error && error.phone">
            <p v-for="(description,index) in error.phone" :key="index">{{description}}</p>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <label for="website" class="col-sm-2 col-form-label">Website</label>
        <div class="col-sm-10">
          <input type="text" class="form-control"  id="website"  placeholder="Website" v-model="user.website" :disabled="loadingUser">
          <div class="mb-3 invalid-feedback-password" v-if="error && error.website">
            <p v-for="(description,index) in error.website" :key="index">{{description}}</p>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-sm-12">
          <button type="submit" class="btn btn-primary mb-2 float-right" v-on:click="updateUserProfile" :disabled="loadingUser"><icon name="settings" class="feather-spin" v-if="loadingUser"></icon> Save</button>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import VuePassword from 'vue-password'
import home from '../../api/home'
import auth from '../../api/auth'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      old_password: null,
      new_password: null,
      countries: null,
      error: null,
      passwordChangeSuccess: null,
      loadingPasswordChange: false,
      updatedUserSuccess: null,
      user: {
        email: null,
        address: null,
        business_name: null,
        city: null,
        country: null,
        full_name: null,
        phone: null,
        postcode: null,
        website: null,
        job_title: null
      }
    }
  },
  mounted () {
    home.getCountries(
      response => {
        this.countries = response
      },
      error => {
        console.log(error)
      })

    // If userprofile has already been loaded, make local copy for edits. Otherwise, we'll make the copy in the watcher
    if (!this.loadingUser) {
      this.user = this.$store.getters['user/getUser']
    }
  },
  components: {
    VuePassword
  },
  methods: {
    changePassword: function () {
      this.error = null
      this.passwordChangeSuccess = null
      this.loadingPasswordChange = true
      auth.changePassword({old_password: this.old_password, new_password: this.new_password},
        response => {
          this.loadingPasswordChange = false
          this.passwordChangeSuccess = true
          this.old_password = null
          this.new_password = null
        },
        error => {
          this.loadingPasswordChange = false
          this.error = error
          console.log(error)
        })
    },
    updateUserProfile: function () {
      this.error = null
      this.updatedUserSuccess = false
      this.$store.dispatch('user/set', this.user).then(() => {
        // Successfully updated user
        this.updatedUserSuccess = true
      }, (error) => {
        // Update failed
        this.updatedUserSuccess = false
        this.error = error
      })
    }
  },
  computed: {
    ...mapGetters('user', {
      loadingUser: 'getLoading'
    })
  },
  watch: {
    loadingUser: function (loading) {
      if (!loading) {
        this.user = this.$store.getters['user/getUser']
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/home/Account.vue